import { Button, Col, Form, Input, Row, Space, theme, Table, message, Popconfirm, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import ModalAddAndEdit from './component/ModalAddAndEdit';
import { employees_create, employees_list, employees_update, getListBranches, employees_delete, getListPositions } from '../../services/apis';
import { HeaderTableCus, TYPE_MODAL } from '../../constants/constants';
import { filterOption } from '../../utils/funcHelper';
import { useSelector } from 'react-redux';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';

const ListEmployeePage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [typeModal, setTypeModal] = useState();
    const [titleModal, setTitleModal] = useState('');
    const [listBranches, setListBranches] = useState([]);
    const [listPositions, setListPositions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(20);
    const [totalRecords, setTotalRecords] = useState(0);
    const userReducer = useSelector(state => state?.userReducer?.data);
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Tên nhân viên',
            dataIndex: 'full_name',
            key: 'full_name',
            render: (text, record, index) => <a onClick={() => handleEditAccount(record)} style={{ paddingLeft: 12, paddingRight: 12 }}>{text}</a>,
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'phone',
            key: 'phone',
            align: 'center',
            render: (text, record, index) => <div>{text}</div>,
        },
        {
            title: 'Địa chỉ',
            dataIndex: 'address',
            key: 'address',
            render: (text, record, index) =>
                <div style={{ paddingLeft: 12, paddingRight: 12 }}>{text}</div>
        },
        {
            title: 'Chức vụ',
            dataIndex: 'position_name',
            key: 'position_name',
            render: (text, record, index) => <div style={{ paddingLeft: 12, paddingRight: 12 }}>{text}</div>,
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record, index) => <div style={{ paddingLeft: 12, paddingRight: 12 }}>{text}</div>,
        },
        {
            title: 'Hành động',
            dataIndex: 'action',
            key: 'action',
            width: 150,
            align: 'center',
            render: (text, record) => (
                record?.username !== 'admin' ?
                    <Space size="middle">
                        <a onClick={() => handleEditAccount(record)} >Sửa</a>
                        <Popconfirm
                            title="Bạn có chắc chắn muốn xoá?"
                            onConfirm={() => handleDelete(record)}
                            okText="Có"
                            cancelText="Không"
                        >
                            <a style={{ color: 'red' }}>Xoá</a>
                        </Popconfirm>

                    </Space> : null
            ),
        },
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const handleEditAccount = (record) => {
        setItemSelected(record);
        setTypeModal(TYPE_MODAL.EDIT);
        setShowModal(true);
        setTitleModal('Sửa thông tin nhân viên');
    }
    const handleAddAccount = () => {
        setTypeModal(TYPE_MODAL.ADD);
        setShowModal(true);
        setTitleModal('Thêm nhân viên');
    }
    const handleDelete = (record) => {
        const payload = {
            ...record,
            status: 2
        }
        callAPIDeleteEmployee(payload);
    }

    const getDataPositions = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await getListPositions(params);
            consoleLogUtil("res getListPositions", res)
            if (res && res.status === 1) {
                setListPositions(res?.data?.map(item => ({ ...item, value: item.id, label: item.name })));
            } else {
                setListPositions([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    }
    const getDataBranches = async () => {
        try {
            const params = {
                keyword: '',
            }
            const res = await getListBranches(params);
            if (res && res.status === 1) {
                setListBranches(res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.name })));
            } else {
                setListBranches([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const getDataEmployees = async (page, showLoading, pageSize) => {
        try {
            const params = {
                keyword: form.getFieldValue('name') ?? '',
                branch_id: form.getFieldValue('branch_id') ?? null,
                limit: pageSize ?? currentPageSize,
                currentPage: page,
            }
            if (showLoading) setLoading(true);
            const res = await employees_list(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
                setTotalRecords(res?.data?.pagination?.total_records ?? 0);
            } else {
                message.error(res.message);
                setData([]);
                setTotalRecords(0);
            }
        } catch (error) {
            setLoading(false);
            message.error('Lỗi kết nối máy chủ, vui lòng thử lại');
            console.log('error', error);
        }


    }

    const onFinish = async (dataForm) => {
        getDataEmployees(1, true);
    };
    const callApiAddEmployee = async (data) => {
        try {
            const params = {
                ...data,
                created_by: userReducer?.user_info?.id ?? ''
            }
            setLoading(true);
            const res = await employees_create(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Thêm nhân viên thành công');
                getDataEmployees(1, true);
            } else {
                message.error(res?.msg || 'Thêm nhân viên không thành công');
            }
        } catch (error) {
            console.log('error', error);
            message.error('Lỗi kết nối máy chủ, vui lòng thử lại');
            setLoading(false);
        }
    }

    const callAPIDeleteEmployee = async (data) => {
        try {
            setLoading(true);
            const res = await employees_delete(data);
            setLoading(false);
            if (res && res.status === 1) {
                getDataEmployees(1, true);
            } else {
                message.error(res?.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            message.error('Lỗi kết nối máy chủ, vui lòng thử lại');
            setLoading(false);
        }
    }

    const callApiUpdateEmployee = async (data) => {
        try {
            setLoading(true);
            const res = await employees_update(data);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Cập nhật thành công');
                getDataEmployees(1, true);
            } else {
                message.error(res?.msg || 'Có lỗi xảy ra, vui lòng thử lại');
            }
        } catch (error) {
            console.log('error', error);
            message.error('Lỗi kết nối máy chủ, vui lòng thử lại');
            setLoading(false);
        }
    }
    const handleOnSave = async (data) => {
        setShowModal(false);
        if (typeModal === TYPE_MODAL.ADD) {
            callApiAddEmployee(data);
        } else {
            callApiUpdateEmployee(data);
        }

    }

    useEffect(() => {
        setLoading(true);
        Promise.all([getDataBranches(), getDataEmployees(1, false, currentPageSize), getDataPositions()]).finally(() => setLoading(false));
    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'name'}
                        >
                            <Input placeholder={'Tìm theo tên, sđt, địa chỉ'} />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name="branch_id"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn cơ sở'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={listBranches}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Space size="small">
                            <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
                                Tìm kiếm
                            </Button>
                            <Button danger onClick={handleAddAccount} icon={<PlusOutlined />}>
                                Thêm tài khoản
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
                pagination={{
                    pageSize: currentPageSize,
                    current: currentPage,
                    total: totalRecords,
                    onChange: (page, size) => {
                        setCurrentPage(page);
                        getDataEmployees(page, true, size);
                    },
                    showSizeChanger: true,
                    showTotal: (total) => `Tổng ${total} nhân viên`,
                    pageSizeOptions: ['20', '30', '50'],
                    onShowSizeChange: (current, size) => {
                        setCurrentPageSize(size);
                        setCurrentPage(1);
                        getDataEmployees(1, true, size);
                    }
                }}
            />
            <LoadingBase loading={loading} />
            <ModalAddAndEdit
                visible={showModal}
                onCancel={() => setShowModal(false)}
                data={itemSelected}
                title={titleModal}
                onSave={handleOnSave}
                lstBranch={listBranches}
                lstPositions={listPositions}
                type={typeModal}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListEmployeePage);